<template lang="pug">
.v-field-text.field-text(:class="[field.maskList ? 'field-text--mask-list' : '']")
	label.field-text__checkbox(v-if="field.checkbox")
		.field-text__checkbox-text(v-if="field.checkbox.text") {{field.checkbox.text}}
		v-field-checkbox(:field="{...field.checkbox, text: null}" :model-value="field.checkbox.value" @update:model-value="handleInputCheckbox")
	template(v-if="field.type === 'textarea'")
		textarea.field-input(
			ref="input"
			:type="computedType"
			:inputmode="field.inputmode"
			:disabled="field.disabled"
			placeholder=" "
			v-model="localValue"
			@input="handleInput"
			@keyup="handleKeyup"
			:id="uniqueId"
			@focus="hasFocus = true"
			@blur="hasFocus = false")
	template(v-else-if="field.mask")
		input.field-input(
			:type="computedType"
			:inputmode="field.inputmode"
			:disabled="field.disabled"
			placeholder=" "
			:value="localValue"
			:id="uniqueId"
			v-imask="computedMask"
			@accept="onAccept"
			@complete="onComplete"
			@focus="hasFocus = true"
			@blur="hasFocus = false")
	template(v-else)
		input.field-input(
			ref="input"
			:type="computedType"
			:inputmode="field.inputmode"
			:disabled="field.disabled"
			placeholder=" "
			v-model="localValue"
			@input="handleInput"
			@keyup="handleKeyup"
			:id="uniqueId"
			@focus="hasFocus = true"
			@blur="hasFocus = false")
	label.field-text__label(v-if="field.label" :for="uniqueId")
		| {{field.label}}
		span.field-text__star(v-if="field.required") &nbsp;*
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';

export default {

	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: [String, Number, Boolean],
			default: null
		}
	},

	emits: [
		'update:model-value',
		'field-complete',
		'update-inner-field',
		'focus'
	],

	data() {
		return {
			localValue: null,
			savedValue: null,
			unmaskedValue: null,
			fullUnmaskedValueLength: 0,
			uniqueId: uniqueId('field-text_'),
			hasFocus: false
		};
	},

	computed: {
		computedMask() {
			if (this.field.mask.mask === 'Number') {
				return {
					'mask': Number,
					'scale': 3,
					'min': this.field.mask['min'],
					'max': this.field.mask['max'],
					'thousandsSeparator': this.field.mask['thousandsSeparator'],
					'radix': this.field.mask['radix'],
					'mapToRadix': this.field.mask['mapToRadix']
				};
			} else {
				return this.field.mask;
			}
		},

		computedType() {
			if (!this.field.type || this.field.type == 'number') {
				return 'text';
			}
			return this.field.type;
		},

		isFieldNumeric() {
			return !!(this.field.type === 'number' || this.field.inputmode === 'numeric' || this.field.inputmode === 'decimal');
		}
	},

	watch: {
		modelValue: {
			immediate: true,
			handler() {
				if (this.isFieldNumeric && this.modelValue) {
					this.localValue = this.savedValue = this.modelValue.toString().replace('.', ',');
				} else {
					this.localValue = this.savedValue = this.modelValue;
				}
			}
		},
		hasFocus(state) {
			if (state) {
				this.$emit('focus');
			}
		},

		localValue(state) {
			if (this.field.maxLength) {
				if (+state.length > +this.field.maxLength) {
					this.localValue = this.localValue.substr(0, +this.field.maxLength);
				}
			}
		}
	},

	methods: {
		onAccept(e) {
			if (e.detail.unmaskedValue.length !== this.fullUnmaskedValueLength) {
				this.handleMasketInput(e);
			}
		},

		onComplete(e) {
			this.handleMasketInput(e);
			this.$emit('field-complete', this.unmaskedValue);
		},

		handleKeyup() {
			if (this.isFieldNumeric && this.savedValue) {
				this.localValue = this.savedValue.replace('.', ',');
			}
		},

		handleMasketInput(e) {
			this.unmaskedValue = e.detail.unmaskedValue;
			this.fullUnmaskedValueLength = this.unmaskedValue.length;
			this.$emit('update:model-value', +this.unmaskedValue ? Math.round(+this.unmaskedValue * 100) / 100 : this.unmaskedValue, this.field);
		},

		handleInput() {
			if (this.isFieldNumeric) {
				if (!this.localValue || /^-?(?:\d+)(?:(\.|,)(\d+)?)?$/.test(this.localValue)) {
					this.savedValue = this.localValue;
				} else {
					this.localValue = this.savedValue;
				}
				this.$emit('update:model-value', this.localValue ? parseFloat(this.localValue.toString().replace(',', '.')) : this.localValue, this.field);
			} else {
				this.$emit('update:model-value', this.localValue, this.field);
			}
		},

		handleInputCheckbox(value, field) {
			this.$emit('update-inner-field', value, {...field, parent: this.field});
		},

		handlerMaskChange(data) {
			this.field.mask.mask = data.value;
		}
	}
};
</script>
